import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Loading from "components/loading.js";

import PropTypes from "prop-types";
import stylesAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import axios from "axios";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import SweetAlert from "react-bootstrap-sweetalert";

import Swal from "sweetalert2";

axios.defaults.withCredentials = true;

const { REACT_APP_SERVER_URL } = process.env;

const stylesCard = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    textAlign: "left",
  },
};

const stylesList = {
  list: {
    display: "inline",
    padding: "5px",
  },
};

const alertOverrides = {
  marginTop: "-100px",
  marginRight: "0px",
  marginBottom: "0px",
  marginLeft: "0px",
};

const useStylesAlert = makeStyles(stylesAlert);

const useStylesCard = makeStyles(stylesCard);
const useStylesList = makeStyles(stylesList);

export default function UserProfile(props) {
  const classesAlert = useStylesAlert();
  const classesCard = useStylesCard();
  const classesList = useStylesList();

  const classes = {
    ...classesAlert,
    ...classesCard,
    ...classesList,
  };

  const [alert, setAlert] = React.useState(null);
  const [name, setName] = React.useState(props.userInfo.name);
  const [institution, setInstitution] = React.useState(
    props.userInfo.institution
  );
  const [about, setAbout] = React.useState(props.userInfo.about);
  const [loading, setLoading] = React.useState(false);

  const { id, email, type } = props.userInfo;

  const hideAlert = () => {
    setAlert(null);
  };

  const successUpdateUser = () => {
    setAlert(
      <SweetAlert
        success
        style={alertOverrides}
        title="Success!"
        onConfirm={() => {
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        {name} has been updated!
      </SweetAlert>
    );
  };

  const failUpdateUser = (errorMessage) => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title={errorMessage ? errorMessage : "Something Went Wrong!"}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        {name} has NOT been updated!
      </SweetAlert>
    );
  };

  const handleSubmitUpdateUser = async (e) => {
    e.preventDefault();

    const postValues = {
      email: email,
      name: name,
      institution: institution,
      about: about,
      type: type,
    };

    let updateProfile;
    /////NEED to change update profile route to see if user exists and if not create a new user.
    try {
      updateProfile = await axios.put(
        `${REACT_APP_SERVER_URL}/users/${id}`,
        {
          ...postValues,
        },
        {
          withCredentials: true,
        }
      );
    } catch ({ response }) {
      updateProfile = response;
    }
    if (updateProfile.status == 200) {
      successUpdateUser();
      getImagesUsers();
    } else {
      failUpdateUser(updateProfile.data.messages.databaseError);
    }
  };

  async function getImagesUsers() {
    props.reloadImagesUsersCallBack(true);
  }

  const handleFileUpload = async (image) => {
    setLoading(true);
    const postValues = {
      fileContents: image,
    };

    let uploadFile;
    /////NEED to change update profile route to see if user exists and if not create a new user.
    try {
      uploadFile = await axios.post(
        `${REACT_APP_SERVER_URL}/images/${id}`,
        {
          ...postValues,
        },
        {
          withCredentials: true,
        }
      );
    } catch ({ response }) {
      uploadFile = response;
    }
    setLoading(false);
    if (uploadFile.status == 200) {
      successUpdateUser();
      getImagesUsers();
    } else {
      failUpdateUser();
    }
  };

  const uploadFile = async () => {
    const { value: file } = await Swal.fire({
      title: "Select or drag image to upload",
      input: "file",
      inputAttributes: {
        accept: "image/*",
        "aria-label": "Upload your profile picture",
      },
    });
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        Swal.fire({
          title: "Your uploaded picture",
          imageUrl: e.target.result,
          imageAlt: "The uploaded picture",
          showCancelButton: true,
          confirmButtonText: "Upload Picture",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            handleFileUpload(e.target.result);
          }
        });
      };
      await reader.readAsDataURL(file);
    }
  };

  return (
    <div>
      {alert}
      <Card profile>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <form onSubmit={handleSubmitUpdateUser}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="Name"
                      id="name"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: name,
                        onChange: (event) => {
                          setName(event.target.value);
                        },
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="Institution"
                      id="institution"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: institution,
                        onChange: (event) => {
                          setInstitution(event.target.value);
                        },
                      }}
                    />
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText={"About Me (Max Characters: 1000)"}
                      id="about"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: about,
                        onChange: (event) => {
                          setAbout(event.target.value);
                        },
                        multiline: true,
                        rows: 5,
                        maxLength: 1000,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <Button
                  color="info"
                  className={classes.updateProfileButton}
                  type="submit"
                >
                  Update Profile
                </Button>
              </form>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
      <Button onClick={uploadFile} color="info" round>
        Update Profile Picture
      </Button>
      {loading && <Loading />}
    </div>
  );
}

UserProfile.propTypes = {
  userInfo: PropTypes.Object,
  reloadUsersCallBack: PropTypes.bool,
  reloadImagesUsersCallBack: PropTypes.bool,
};

